import clsx from 'clsx';
import React from 'react';
import {Link} from 'react-router-dom';

import {
  useShellHeaderBreadcrumbs,
  useShellHeaderShowProductCrumb,
} from './ShellHeaderContext';
import {catalogHref, shellRouteClaimTable} from '../routeClaims';
import {type ForgeProduct} from './forgeProducts';
import css from './ForgeHeaderBreadcrumbs.module.css';

const Separator = () => <span className={css.separator}>/</span>;

type ForgeHeaderBreadcrumbsProps = {
  product: ForgeProduct;
};

export const ForgeHeaderBreadcrumbs = ({
  product,
}: ForgeHeaderBreadcrumbsProps) => {
  const breadcrumbs = useShellHeaderBreadcrumbs();

  const productPath = catalogHref(product, shellRouteClaimTable());
  const productHref =
    productPath != null ? `${productPath}?overview` : undefined;
  const hasBreadcrumbs = breadcrumbs != null && breadcrumbs.length > 0;
  const showProductCrumb = useShellHeaderShowProductCrumb() || !hasBreadcrumbs;

  return (
    <nav
      aria-label="Breadcrumb navigation"
      className={css.breadcrumbs}
      data-testid="forge-header-breadcrumbs">
      {showProductCrumb &&
        (productHref != null ? (
          <Link
            className={clsx(
              css.crumb,
              css.crumbLink,
              !hasBreadcrumbs && css.activeCrumb
            )}
            title={product.label}
            to={productHref}>
            {product.label}
          </Link>
        ) : (
          <span className={clsx(css.crumb, !hasBreadcrumbs && css.activeCrumb)}>
            {product.label}
          </span>
        ))}
      {breadcrumbs?.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        return (
          <React.Fragment key={`${crumb.label}:${crumb.href}`}>
            {(showProductCrumb || index > 0) && <Separator />}
            {crumb.href != null ? (
              <Link
                className={clsx(
                  css.crumb,
                  css.crumbLink,
                  isLast && css.activeCrumb
                )}
                title={crumb.label}
                to={crumb.href}>
                {crumb.label}
              </Link>
            ) : (
              <span className={clsx(css.crumb, isLast && css.activeCrumb)}>
                {crumb.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
